import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_USER_SMART_VIEWS,
  CREATE_USER_SMART_VIEWS,
  UPDATE_USER_SMART_VIEWS,
  DELETE_USER_SMART_VIEWS,
} from "./actionTypes"

import {
  getUserSmartViewsSuccess,
  getUserSmartViewsError,
  createUserSmartViewsSuccess,
  createUserSmartViewsError,
  updateUserSmartViewsSuccess,
  updateUserSmartViewsError,
  deleteUserSmartViewsSuccess,
  deleteUserSmartViewsError
} from "./actions"

import { genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetUserSmartViews() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_smart_views`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(getUserSmartViewsError(error))
  }
}

function* onCreateUserSmartViews(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_smart_views`,
      {
        body: JSON.stringify({
          ...action.payload.body
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(createUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(createUserSmartViewsError(error))
  }
}

function* onUpdateUserSmartViews(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_smart_views/${action.payload.ids.join(',')}`,
      {
        body: JSON.stringify({
          ...action.payload.body
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(updateUserSmartViewsError(error))
  }
}

function* onDeleteUserSmartViews() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/sf_smart_views`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(deleteUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(deleteUserSmartViewsError(error))
  }
}

function* sfCommonDataSaga() {
  yield takeEvery(GET_USER_SMART_VIEWS, onGetUserSmartViews)
  yield takeEvery(CREATE_USER_SMART_VIEWS, onCreateUserSmartViews)
  yield takeEvery(UPDATE_USER_SMART_VIEWS, onUpdateUserSmartViews)
  yield takeEvery(DELETE_USER_SMART_VIEWS, onDeleteUserSmartViews)
}

export default sfCommonDataSaga;
